import { useTranslation } from 'react-i18next';

import { useStore } from '@stores';
import { statesList } from '@utils';

import { ControlledSelect } from '../../common/ControlledSelect';
import { ZipCode } from '../zipCode';

export const State = () => {
  const { t } = useTranslation('subModules/state');
  const { featureFlagStore } = useStore();
  const { enableZipCodeField } = featureFlagStore.featureFlags;

  if (enableZipCodeField) {
    return <ZipCode />;
  }

  return (
    <ControlledSelect
      fieldName="state"
      label={t('label')}
      placeholder={t('placeholder')}
      options={statesList}
      data-tf-sensitive="true"
      required
    />
  );
};
